import { Modal } from '@/components/Modal';
import { SeatMapView } from '@/pages/hr/SeatMapView';

/**
 * 직원찾기 명함의 「자리배치도 보기」 가 여는 창 — 인력배치표의 자리배치도 보기와 <b>같은 판</b>을
 * 그 사람의 층으로 펴고 이름표를 두드러지게 그린다.
 *
 * <p><b>보기만이다</b>(사용자 지시 2026-10-01). 끌기·자리 편집은 인력배치표에서만 — 찾는 자리에서
 * 고치지 않는다(직원찾기의 조직도가 편집 손잡이를 안 받는 것과 같은 판단).
 */
export function SeatMapModal({ personnelId, name, onClose }: { personnelId: string; name: string; onClose: () => void }) {
  return (
    <Modal title={`자리배치도 · ${name}`} onClose={onClose} maxWidth="1200px">
      <SeatMapView focusPersonnelId={personnelId} readOnly />
    </Modal>
  );
}
